import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CustomerGroup from './customerGroup'
import AddCustomer from './addCustomer'
import CustomerImport from "./CustomerImport";
const customerParent = ({ match }) => (
    <Switch>
          <Route path={`${match.url}/customergroup`} render={props => <CustomerGroup {...props} />} />
            <Route exact path={`${match.url}/addcustomer`} render={props => <AddCustomer {...props} />} />  
         <Route path={`${match.url}/addcustomer/:options`} render={props => <AddCustomer {...props} />} />
         <Route path={`${match.url}/import`} component={CustomerImport} />
           {/* <Route exact path={`${match.url}/addcustomer/:options`} component={AddCustomer}/> */}
    </Switch>
);

export default customerParent;